import * as Yup from "yup";

export const dataModel = {
  courseUuid: "",
  employee: "",
  initDate: "",
  endDate: "",
  centerUuid: "",
  completed: "",
};

export const validationDataModel = Yup.object().shape({
  courseUuid: Yup.string().optional(""),
  employee: Yup.string().optional(""),
  initDate: Yup.date().optional("Fecha inválida"),
  endDate: Yup.date().optional("Fecha inválida"),
  centerUuid: Yup.string().optional(""),
  completed: Yup.mixed().optional(""),
});

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
